<template lang="pug">
.listing-item
  v-card.round-xl(outlined)
    v-row(no-gutters)
      v-col(cols="2" xl="1" :class="{'mr-8':isLargerScreen}")
        v-avatar.ma-4(color="basic300")
          v-img(v-if="profilePhoto" :src="profilePhoto" :alt="`${name}-profile-photo`")
          span.text-md.font-semibold.neutral500--text(v-else) {{ getInitial(name) }}
      v-col
        div(:class="[{ 'ml-8': isMobileScreen }]")
          .d-flex.justify-space-between.align-start.mt-4.mb-3
            div
              div.d-flex.align-center
                .text-sm.font-semibold {{ name }}
                v-card.success100.success700--text.d-flex.align-center.px-1.ml-2.round-md(v-if="existingCustomerBadge" outlined)
                  v-icon.mr-1(color="success700" size="15") $yzi-check-verified-02
                  .text-xs.font-normal.pr-1 {{ $t('existing_item', { item: existingItemText }) }}
              .text-xs.font-normal.neutral500--text {{ dateTime }}
            slot(name="itemAction")
        .d-flex.align-center(:class="[{ 'ml-8': isMobileScreen }]")
          v-icon.mr-2(v-if="responseType === 'googleReview'") $yzi-google-icon
          star-generator(:totalStar="5" :star="star" :size="20" classes="mr-2")
    listing-comment-item(v-if="comment" :comment="comment")
    listing-response-item.mt-3.pr-4(v-if="response && !isEditingResponse" :responseType="responseType" :response="response" :rightBtnText="$t('delete')" :leftBtnText="$t('edit')" :rightBtnLoading="isDeletingResponse" @rightBtnClicked="$emit('deleteResponse')" @leftBtnClicked="$emit('editResponse')")
    v-divider.my-4
    .d-flex.justify-end.ma-4(v-if="!overrideBottomView")
      template(v-if="leftBtnText")
        v-tooltip(v-if="leftBtnTooltipText" top color="black" content-class="black tooltip-top-arrow" max-width="250px" open-delay="200")
          template(v-slot:activator="{ on, attrs }")
            v-btn.button-sm.mr-4(v-bind="attrs" v-on="on" outlined @click="$emit('leftBtnClicked')") {{ leftBtnText }}
          .c1.white--text {{ leftBtnTooltipText }}
        v-btn.button-sm.mr-4(v-else outlined @click="$emit('leftBtnClicked')") {{ leftBtnText }}
      v-btn.button-sm(color="neutral700" :dark="!rightBtnDisabled" depressed :disabled="rightBtnDisabled" @click="$emit('rightBtnClicked')") {{ rightBtnText }}
    slot(v-else name="bottomView")
</template>

<script>
import StarGenerator from '@/components/review/general/StarGenerator.vue'
import ListingCommentItem from '@/components/review/listing/ListingCommentItem.vue'
import ListingResponseItem from '@/components/review/listing/ListingResponseItem.vue'

export default {
  name: 'ListingItem',
  components: {
    StarGenerator,
    ListingCommentItem,
    ListingResponseItem
  },
  props: {
    name: {
      type: String,
      required: true 
    },
    profilePhoto: {
      type: String,
      default: null 
    },
    dateTime: {
      type: String,
      required: true 
    },
    star: {
      type: Number,
      required: true 
    },
    comment: {
      type: String,
      default: null 
    },
    response: {
      type: String,
      default: null 
    },
    rightBtnText: {
      type: String,
      required: true 
    },
    leftBtnText: {
      type: String,
      default: null 
    },
    rightBtnDisabled: {
      type: Boolean
    },
    leftBtnTooltipText: {
      type: String,
      default: null
    },
    existingCustomerBadge: {
      type: Boolean
    },
    overrideBottomView: {
      type: Boolean
    },
    responseType: {
      type: String,
      required: true,
      validator(value) {
        return ['googleReview', 'feedback'].includes(value)
      }
    },
    isDeletingResponse: {
      type: Boolean
    },
    isEditingResponse: {
      type: Boolean
    },
    os: {
      type: String,
      default: 'review',
      validator(value) {
        return ['clinic', 'donation', 'connect', 'review'].includes(value)
      }
    },
  },
  computed: {
    isLargerScreen() {
      return this.$vuetify.breakpoint.xl
    },
    isMobileScreen () {
      return this.$vuetify.breakpoint.xs
    },
    existingItemText() {
      switch (this.os) {
        case 'clinic':
          return this.$t('patient').toLowerCase()

        case 'review':
          return this.$t('customer').toLowerCase()
      
        default:
          return ''
      }
    }
  },
  methods: {
    getInitial(value) {
      let name = value
      let rgx = new RegExp(/(\p{L}{1})\p{L}+/, 'gu');
      let initials = [...name.matchAll(rgx)] || [];
      initials = ((initials.shift()?.[1] || '') + (initials.pop()?.[1] || '')).toUpperCase();
      return initials
    }
  },
}
</script>

<style scoped>
</style>